import { shortenAddress } from '../../../../helpers/address';

export const DaoRedirectBadge = ({ name, isLabelAddress, isToScan, text, redirectUrl }) => {
  return (
    <button
      className='flex rounded-[6px] border border-[#7445FF] bg-[#7445ff4d] px-[12px] py-[8px] text-[12px]'
      onClick={() => {
        window.open(redirectUrl, '_blank');
      }}
    >
      {name}
      <span className='ml-4'>{isLabelAddress ? shortenAddress(text) : text}</span>
      {isToScan ? (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='13'
          height='12'
          viewBox='0 0 13 12'
          fill='none'
          className='ml-2 mt-1'
        >
          <g clipPath='url(#clip0_15_224)'>
            <path
              d='M2.49447 5.71311C2.49449 5.64611 2.50773 5.57977 2.53346 5.5179C2.55918 5.45603 2.59687 5.39985 2.64436 5.35259C2.69185 5.30533 2.74821 5.26791 2.8102 5.24249C2.87219 5.21707 2.9386 5.20415 3.0056 5.20446L3.85298 5.20723C3.9881 5.20723 4.11767 5.2609 4.21321 5.35644C4.30875 5.45198 4.36242 5.58156 4.36242 5.71667V8.92107C4.45786 8.89279 4.58001 8.86262 4.71441 8.83097C4.80753 8.80906 4.89052 8.75634 4.94992 8.68136C5.00932 8.60638 5.04166 8.51353 5.04168 8.41786V4.44331C5.04168 4.30819 5.09535 4.1786 5.19089 4.08305C5.28642 3.98749 5.416 3.9338 5.55112 3.93377H6.40108C6.5362 3.9338 6.66578 3.98749 6.76131 4.08305C6.85685 4.1786 6.91052 4.30819 6.91052 4.44331V8.13234C6.91052 8.13234 7.12316 8.04629 7.33016 7.95886C7.40708 7.92633 7.47272 7.87187 7.51889 7.80227C7.56505 7.73267 7.58971 7.65103 7.58977 7.56751V3.16966C7.58977 3.03457 7.64343 2.905 7.73895 2.80947C7.83447 2.71393 7.96402 2.66025 8.09912 2.66022H8.94818C9.08321 2.66035 9.21266 2.71408 9.30809 2.80961C9.40352 2.90513 9.45713 3.03464 9.45713 3.16966V6.79113C10.1933 6.25766 10.9393 5.61599 11.5313 4.84446C11.6172 4.73246 11.674 4.60095 11.6967 4.46165C11.7194 4.32236 11.7073 4.1796 11.6614 4.04613C11.3874 3.2577 10.9518 2.53516 10.3825 1.92475C9.81315 1.31433 9.12267 0.829491 8.35523 0.501242C7.58778 0.172994 6.76025 0.00856917 5.92561 0.01849C5.09097 0.0284109 4.2676 0.212459 3.50817 0.558856C2.74874 0.905253 2.06998 1.40637 1.51534 2.03014C0.960693 2.65392 0.542371 3.3866 0.287141 4.18133C0.0319108 4.97605 -0.0546059 5.8153 0.0331265 6.64537C0.120859 7.47545 0.380908 8.27807 0.796634 9.00188C0.869063 9.12674 0.975623 9.22834 1.10379 9.29473C1.23196 9.36113 1.37642 9.38957 1.5202 9.37671C1.68081 9.36257 1.88079 9.34259 2.11855 9.3147C2.22203 9.30293 2.31756 9.25351 2.38696 9.17585C2.45635 9.09819 2.49476 8.99772 2.49487 8.89358V5.71311'
              fill='#131740'
              className='fill-[#131740] dark:fill-white'
            />
            <path
              d='M2.47638 10.8521C3.37136 11.5032 4.42901 11.894 5.53231 11.9813C6.63562 12.0686 7.74156 11.849 8.72779 11.3468C9.71402 10.8445 10.5421 10.0792 11.1204 9.13558C11.6987 8.19192 12.0046 7.10669 12.0044 5.99993C12.0044 5.86147 11.998 5.72518 11.9888 5.58929C9.79686 8.85848 5.74962 10.3868 2.47638 10.8521Z'
              fill='#131740'
            />
          </g>
          <defs>
            <clipPath id='clip0_15_224'>
              <rect width='12.0044' height='12' fill='white' />
            </clipPath>
          </defs>
        </svg>
      ) : (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='12'
          height='12'
          viewBox='0 0 12 12'
          fill='none'
          className='ml-2 mt-1'
        >
          <path
            d='M9 9.5H3C2.725 9.5 2.5 9.275 2.5 9V3C2.5 2.725 2.725 2.5 3 2.5H5.5C5.775 2.5 6 2.275 6 2C6 1.725 5.775 1.5 5.5 1.5H2.5C1.945 1.5 1.5 1.95 1.5 2.5V9.5C1.5 10.05 1.95 10.5 2.5 10.5H9.5C10.05 10.5 10.5 10.05 10.5 9.5V6.5C10.5 6.225 10.275 6 10 6C9.725 6 9.5 6.225 9.5 6.5V9C9.5 9.275 9.275 9.5 9 9.5ZM7 2C7 2.275 7.225 2.5 7.5 2.5H8.795L4.23 7.065C4.035 7.26 4.035 7.575 4.23 7.77C4.425 7.965 4.74 7.965 4.935 7.77L9.5 3.205V4.5C9.5 4.775 9.725 5 10 5C10.275 5 10.5 4.775 10.5 4.5V2C10.5 1.725 10.275 1.5 10 1.5H7.5C7.225 1.5 7 1.725 7 2Z'
            fill='#131740'
            className='fill-[#131740] dark:fill-white'
          />
        </svg>
      )}
    </button>
  );
};
